/* Shared behaviour for the corporate and policy pages. 2026-10-20 */
(() => {
  const roots = document.querySelectorAll('.cwx'); if (!roots.length) return;
  const red = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.cwx .rv').forEach(el => io.observe(el));

  /* counters: data-count, optional data-from, data-suffix, data-plain (no grouping) */
  const fmt = (n, plain) => plain ? String(n) : n.toLocaleString('en-IN');
  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return; cio.unobserve(e.target);
    const b = e.target, end = +b.dataset.count, from = +(b.dataset.from || 0), suf = b.dataset.suffix || '', plain = 'plain' in b.dataset;
    if (red) { b.textContent = fmt(end, plain) + suf; return; }
    const t0 = performance.now(), d = 1600;
    const step = t => { const k = Math.min(1, (t - t0) / d), v = Math.round(from + (end - from) * (1 - Math.pow(1 - k, 3))); b.textContent = fmt(v, plain) + (k === 1 ? suf : ''); if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }), { threshold: .4 });
  document.querySelectorAll('.cwx [data-count]').forEach(b => cio.observe(b));

  /* scroll-driven timeline */
  document.querySelectorAll('.cwx .tl').forEach(tl => {
    const ms = [...tl.querySelectorAll('.ms')];
    const upd = () => { const r = tl.getBoundingClientRect(), mid = innerHeight * .62; const p = Math.max(0, Math.min(1, (mid - r.top) / r.height)); tl.style.setProperty('--p', p.toFixed(4)); ms.forEach(m => { const mr = m.getBoundingClientRect(); m.classList.toggle('on', mr.top + 30 < mid); }); };
    upd(); addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd);
  });

  /* auto-cycling steppers: .steps[data-cycle] */
  document.querySelectorAll('.cwx .steps[data-cycle]').forEach(s => {
    const st = [...s.querySelectorAll('.st')]; let i = 0, timer = null;
    const show = k => { i = k; st.forEach((x, j) => x.classList.toggle('on', j <= k)); s.style.setProperty('--sp', st.length > 1 ? k / (st.length - 1) : 1); const cap = s.parentElement.querySelector('[data-stepcap]'); if (cap) cap.innerHTML = st[k].dataset.cap || ''; };
    const run = () => { if (timer) return; timer = setInterval(() => show((i + 1) % st.length), +(s.dataset.cycle) || 2200); };
    st.forEach((x, j) => x.addEventListener('click', () => { clearInterval(timer); timer = null; show(j); }));
    show(0);
    if (!red) new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) run(); else { clearInterval(timer); timer = null; } }), { threshold: .3 }).observe(s);
  });

  /* table of contents highlight */
  document.querySelectorAll('.cwx .toc').forEach(toc => {
    const links = [...toc.querySelectorAll('a[href^="#"]')], secs = links.map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);
    const tio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) links.forEach(a => a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id)); }), { rootMargin: '-30% 0px -60% 0px' });
    secs.forEach(s => tio.observe(s));
  });
})();
